class SignupPageExtension {
	constructor(rootStore) {
		this.rootStore = rootStore;
	}

	get proSignupFunnelStore() {
		const { proSignupFunnelStore } = this.rootStore.stores;
		return proSignupFunnelStore;
	}

	get zipcode() {
		return this.proSignupFunnelStore.Zipcode.value;
	}

	get service() {
		return this.proSignupFunnelStore.Service.value;
	}

	signupWithFb(...args) {
		return this.proSignupFunnelStore.Signup.signupWithFb(...args);
	}

	signupWithGoogle(...args) {
		return this.proSignupFunnelStore.Signup.signupWithGoogle(...args);
	}

	signup(...args) {
		return this.proSignupFunnelStore.Signup.signup(...args);
	}

	updateZipcode(...args) {
		return this.proSignupFunnelStore.Zipcode.update(...args);
	}
}

export default SignupPageExtension;
